module.exports = __webpack_public_path__ + "static/media/image 98.344cc1de.webp";